import { type Common } from './common.js';
import type * as InsuranceCardOcrResult from './models/insuranceOcrResult.js';
import type * as PatientUpload from './models/patientUpload.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findMaybeOneByPatientInsuranceInformationId(
    patientInsuranceInformationId: string,
    side?: PatientUpload.InsuranceCardSide
  ): Promise<InsuranceCardOcrResult.InsuranceCardOcrResult | null> {
    const url = this.common.constructPath('/insurance-ocr-results/', {
      patientInsuranceInformationId,
      side,
    });
    const { insuranceOcrResult } = await this.common.getJSON(url);
    return insuranceOcrResult;
  }

  async update(
    id: string,
    values: InsuranceCardOcrResult.UpdateValues
  ): Promise<InsuranceCardOcrResult.InsuranceCardOcrResult> {
    const url = this.common.constructPath(`/patient-previsit/insurance-ocr-results/${id}`);
    const { insuranceOcrResult } = await this.common.patchJSON(url, values);
    return insuranceOcrResult;
  }

  async downloadOcrText(id: string): Promise<InsuranceCardOcrResult.TextractTextWithBoundingBox[]> {
    const url = this.common.constructPath(`/insurance-ocr-results/${id}/textract-ocr-text`);
    return await this.common.getJSON(url);
  }
}
